export default __webpack_public_path__ + "static/terms-and-policies-generator-c7d764476a14d75633806b6ab4248414.png";